// extracted by mini-css-extract-plugin
export default {"productGrid":"UY-z","centerLink":"VY-z","productSection":"WY-z","item":"XY-z","ctaButton":"YY-z"};